import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { EventsApi } from "./api";
import { CustomersApi } from "../Customers/api";
import { ServiceCallsApi } from "../ServiceCalls/api";
import { SparepartsApi } from "../Spareparts/api";
import { MachineInfoApi } from "../MachineInfo/api";
import moment from "moment";
import Spinner from "../Common/Components/spinner";

type handler = () => void;
interface downloadDialogProps {
  visible: boolean;
  toggleVisible: handler;
  ids: any;
}

const DownloadReportDialog = (props: downloadDialogProps) => {
  const defaultMachineDataTypes = [
    { Id: 1, Name: "String" },
    { Id: 2, Name: "Integer" },
    { Id: 3, Name: "Decimal" },
    { Id: 4, Name: "Boolean" },
  ];
  const defaultEntryTypes = [
    { Id: 0, Name: "Trip" },
    { Id: 1, Name: "Work" },
    { Id: 4, Name: "Prep" },
    { Id: 5, Name: "MachineData" },
  ];

  const [loadingWorkLogs, updateLoadingWorkLogs] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [issue, updateIssue] = useState(null);
  const [formattedReportData, updateFormattedReportData] = useState(null);
  const [dataArea, updateDataArea] = useState(null);
  const [report, updateReport] = useState(null);
  const [reportLoading, updateReportLoading] = useState(true);
  const [error, updateError] = useState(false);

  useEffect(() => {
    if (props.ids != null) {
      getReport();
    }
  }, [props.ids]);

  useEffect(() => {
    if (formattedReportData != null) {
      createPdf();
    }
  }, [formattedReportData]);
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (report != null) {
      getReportData(signal);
    }
    return () => controller.abort();
  }, [report]);

  const getReportData = (signal: any) => {
    updateReportLoading(true);
    updateError(false);
    Promise.all([
      getCustomerData(),
      getServiceCallSubject(signal),
      getSpareParts(signal),
      getEventEntries(signal),
      getServiceUnit(signal),
      getProjectNumber(signal),
    ]).then(function (valArray) {
      const custData = valArray[0];
      let newReport: any = report;
      newReport.svcCallSubject = valArray[1];
      const spareParts = valArray[2];
      const eventEntries = valArray[3];
      const serviceUnit = valArray[4];
      const projectNumber = valArray[5];

      updateFormattedReportData(
        formatReportData(
          newReport,
          custData,
          eventEntries,
          defaultEntryTypes,
          defaultMachineDataTypes,
          spareParts,
          serviceUnit,
          projectNumber
        )
      );
    });
  };
  const getReport = () => {
    EventsApi.getEvent({ eventId: props.ids.eventId })
      .then((response: any) => {
        if (response != "canceled") {
          //console.log(response);
          if (response.dataArea != null) {
            updateDataArea(response.dataArea);
          } else {
            updateDataArea("ffi");
          }
          let _report = response;
          _report.approveDateUI = moment(_report.approveDate).format(
            "DD.MM.YYYY"
          );
          if (_report.approveDateUI == "01.01.1970")
            _report.approveDateUI = null;
          _report.servicePersonnelUI = _report.servicePersonnel.replace(
            /;/g,
            "\n"
          );
          _report.servicePersonnelArray =
            _report.servicePersonnelUI.split("\n");

          updateReport(_report);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
        }
        console.log(error);
      });
  };
  const getCustomerData = () => {
    const newParams: any = {
      customerID: props.ids.customerId,
    };
    return CustomersApi.getCustomerInfo(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          return response;
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
        }
        return error;
      });
  };
  const getServiceCallSubject = (signal: any) => {
    return ServiceCallsApi.getCustomerServiceCalls(
      { customerId: report.customerID },
      signal
    )
      .then((response: any) => {
        //console.log(response, report);
        const serviceCalls = response;
        let subject = report.svcCallSubject;
        if (subject == null || subject == undefined) {
          for (let i = 0; i < serviceCalls.length; i++) {
            if (serviceCalls[i].svcCallNum == report.svcCallId)
              subject = serviceCalls[i].svcCallSubject;
          }
        }
        if (subject == null || subject == undefined)
          subject = report.faultDescription;
        return subject;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };
  const getSpareParts = (signal: any) => {
    return SparepartsApi.getUsedSpareparts({ reportId: report.rowKey }, signal)
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };
  const getProjectNumber = (signal: any) => {
    return MachineInfoApi.getProjectNumber(
      { machineSerial: report.machineSN },
      signal
    )
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };
  const getEventEntries = (signal: any) => {
    return EventsApi.getEventEntries({ reportId: report.rowKey }, signal)
      .then((response: any) => {
        for (var i = 0; i < response.length; i++) {
          let e = response[i];
          e.edit = false;
          e.duration = moment(e.eventEnd).diff(
            moment(e.eventStart),
            "hours",
            true
          );
          e.dateUI = moment(e.date).format("DD.MM.YYYY");
          e.dateUIEnd = moment(e.eventEnd).format("DD.MM.YYYY");
          e.startTimeString = moment(e.eventStart).format("HH:mm");
          e.endTimeString = moment(e.eventEnd).format("HH:mm");
        }

        return response;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };
  const getServiceUnit = (signal: any) => {
    return CustomersApi.getServiceUnit(
      { customerId: report.localServiceUnit },
      signal
    )
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };

  const formatReportData = (
    _report: any,
    customer: any,
    events: any,
    entryTypes: any,
    machineDataTypes: any,
    spareparts: any,
    serviceUnit: any,
    projectNumber: any
  ) => {
    var reportData: any = {};
    reportData.ReportId = _report.eventID;
    reportData.ReportDate = moment(_report.created).format("DD.MM.YYYY");
    reportData.ReportFinnishDate = "";
    var fDate = moment(_report.approveDateUI).format("DD.MM.YYYY");
    if (_report.signaturePlaceDate != null)
      reportData.ReportFinnishDate += _report.signaturePlaceDate;
    if (_report.approveDateUI != null)
      reportData.ReportFinnishDate += ", " + fDate;
    reportData.CustomerName = _report.customerName;
    reportData.CustomerAddress = customer.street;
    reportData.PoBox = "";
    reportData.CustomerPostalCode = customer.zipCode;
    reportData.CustomerCity = customer.city;
    reportData.CustomerCountry = customer.country;
    reportData.Machine = _report.machineSN;
    reportData.ServiceCall = _report.svcCallId;
    reportData.ProjectID = projectNumber;
    //reportData.ServiceSubject = _report.problemText;

    if (_report.problemText)
      reportData.ServiceSubject = _report.problemText.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    else reportData.ServiceSubject = _report.svcCallSubject;
    if (
      reportData.ServiceSubject == "" ||
      reportData.ServiceSubject == undefined ||
      reportData.ServiceSubject == null
    ) {
      reportData.ServiceSubject = _report.faultDescription;
    }
    if (serviceUnit != null) {
      reportData.ServiceUnitName = serviceUnit.customerName;
      reportData.ServiceUnitAddress = serviceUnit.streetAddress;
      reportData.ServiceUnitCity = serviceUnit.city;
      if (serviceUnit.country != null) {
        reportData.ServiceUnitCountry = serviceUnit.country.toUpperCase();
      }
      reportData.ServiceUnitPhone = serviceUnit.phone;
      reportData.ServiceUnitFax = serviceUnit.fax;
      reportData.ServiceUnitEmail = serviceUnit.email;
      reportData.ServiceUnitWebSite = serviceUnit.website;
    }

    if (report.hotel == "True") reportData.Hotel = "checked";
    else reportData.Hotel = "unchecked";
    if (report.airplane == "True") reportData.Airplane = "checked";
    else reportData.Airplane = "unchecked";
    if (report.rentalCar == "True") reportData.RentalCar = "checked";
    else reportData.RentalCar = "unchecked";
    if (report.otherCosts == "True") reportData.OtherCosts = "checked";
    else reportData.OtherCosts = "unchecked";

    reportData.TotalDist = _report.totalDistance;
    reportData.WorkingHours = _report.workHours;
    reportData.TravellingHours = _report.travelHours;
    reportData.PrepHours = _report.prepTimeHours;
    if (reportData.SafertDevicesDescription)
      reportData.SafertDevicesDescription = _report.safetyDevices.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    else reportData.SafertDevicesDescription = _report.safetyDevices;

    reportData.ServicePerson = _report.servicePersonnelUI;
    reportData.ServicePersonSignature = _report.signaturePersonnel;
    reportData.CustomerSignature = _report.signatureCustomer;
    if (_report.approverComments)
      reportData.MoreInfo = _report.approverComments.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    else reportData.MoreInfo = _report.approverComments;
    if (_report.serviceOperations)
      reportData.ServiceOperations = _report.serviceOperations.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    else reportData.ServiceOperations = _report.serviceOperations;
    if (_report.unusedpartsInfo)
      reportData.ActionsForUnusedParts = _report.unusedpartsInfo.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    else reportData.ActionsForUnusedParts = _report.unusedpartsInfo;
    if (_report.workType.indexOf("PM;") > -1)
      reportData.PreventativeMaintenance = "checked";
    else reportData.PreventativeMaintenance = "unchecked";
    if (_report.workType.indexOf("Warranty;") > -1)
      reportData.Warranty = "checked";
    else reportData.Warranty = "unchecked";
    if (_report.workType.indexOf("Contract;") > -1)
      reportData.Contract = "checked";
    else reportData.Contract = "unchecked";
    if (_report.workType.indexOf("CM;") > -1)
      reportData.CorrectiveMaintenance = "checked";
    else reportData.CorrectiveMaintenance = "unchecked";
    if (_report.workType.indexOf("ServiceAgreement;") > -1)
      reportData.ServiceAgreement = "checked";
    else reportData.ServiceAgreement = "unchecked";
    if (_report.workType.indexOf("Installation;") > -1)
      reportData.InstallationTraining = "checked";
    else reportData.InstallationTraining = "unchecked";
    if (_report.workType.indexOf("OnlineServices;") > -1)
      reportData.OnlineServices = "checked";
    else reportData.OnlineServices = "unchecked";

    if (_report.safetyDevb1) reportData.SafetyDevicesChecked = "checked";
    else reportData.SafetyDevicesChecked = "unchecked";
    if (_report.safetyDevb2) reportData.SafetyModifiedByCustomer = "checked";
    else reportData.SafetyModifiedByCustomer = "unchecked";

    var reportEvents = [];
    var reportMachineDatas = [];
    for (let i = 0; i < events.length; i++) {
      let e = events[i];
     // console.log(e);
      if (e.entryType != 5) {
        var reportE: any = {};
        reportE.Date = e.dateUI;
        reportE.StartTime = e.startTimeString;
        reportE.EndTime = e.endTimeString;

        for (let i = 0; i < entryTypes.length; i++) {
          let eT = entryTypes[i];
          if (eT.Id == e.entryType) {
            reportE.Type = eT.Name;
          }
        }
        reportE.ServicePerson = e.servicePerson;
        reportE.Description = e.subject;
        reportE.Duration = e.duration.toFixed(2).toString() + "h";
        reportE.Distance = e.kilometers.toString() + "km";
        reportEvents.push(reportE);
      } else {
        var reportM: any = {};
        reportM.Header = e.machDataType;
        reportM.Unit = e.machType;
        reportM.Value = e.machDataValue;
        for (let k = 0; k < machineDataTypes.length; k++) {
          let eT = machineDataTypes[k];
          if (eT.Id == e.machDataValueType) {
            reportM.Type = eT.Name;
          }
        }
        reportMachineDatas.push(reportM);
      }
    }
    reportData.Events = reportEvents;
    reportData.MachineDatas = reportMachineDatas;

    var reportSpareparts = [];
    for (let i = 0; i < spareparts.length; i++) {
      let s = spareparts[i];
      var reportS: any = {};
      reportS.Code = s.code;
      reportS.Description = s.sparepart;
      reportS.Quantity = s.quantity;
      reportS.Freetext = s.text;
      reportSpareparts.push(reportS);
    }
    reportData.Spareparts = reportSpareparts;
   // console.log(reportData, report);
    return reportData;
  };

  const createPdf = () => {
    EventsApi.createServiceReportPdf({
      data: formattedReportData,
      template: { shortid: "HJDLOQpml" },
      options: { "Content-Disposition": 'attachment; FileName="report.pdf"' },
    })
      .then((response: any) => {
        if (response != "canceled") {
          //   var pdfWin= window.open("data:application/pdf;base64, " + data, '', 'height=650,width=840');
          var file = new Blob([response], { type: "application/pdf" });
          // IE 10 / 11
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "report.pdf");
          } else {
            const data = window.URL.createObjectURL(file);
            var link = document.createElement("a");
            link.href = data;

            var svc = report.svcCallId;
            if (svc == null) svc = "No service call";
            var cust = report.customerName;
            if (cust == null) cust = "No customer";
            var eventString = "-";
            if (report.eventID != null) {
              eventString = report.eventID.toString();
            }
            var fileName =
              svc + " - " + cust + " - Service report ID " + eventString;
            link.download = fileName + ".pdf";
            link.click();

            //setTimeout(() => {
            //    window.URL.revokeObjectURL(data);

            //}, 100)
            setTimeout(function () {
              window.URL.revokeObjectURL(data);
            }, 100);

            //var fileURL = URL.createObjectURL(file);
            //fileURL.download = "test.pdf";
            //window.open(fileURL);
          }
        }
        updateReportLoading(false);
        updateError(false);
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateReportLoading(false);
          updateError(true);
        }
        console.log(error);
      });
  };
  const renderContent = () => {
    if (reportLoading) {
      return <Spinner text="data" />;
    } else if (error) {
      return <div>Unable to download report</div>;
    } else {
      return <div>Report successfully downloaded</div>;
    }
  };
  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog
          title={"Download Service Report"}
          onClose={props.toggleVisible}
          width={600}
        >
          <div style={{ backgroundColor: "#fff", padding: "20px" }}>
            {renderContent()}
          </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default DownloadReportDialog;
